<template>
  <header class="flex flex-col items-center justify-center bg-white">    
    <div class="w-full">

      <div class="w-full h-1" style="background-color: #3c3c3a;"></div>

      <div class="py-10 flex flex-col items-center max-h-full">
        <img class="w-7/12" src="@/assets/header.png"/>
      </div>

      <div class="w-full h-1" style="background-color: #3c3c3a;"></div>

      <div class="flex justify-center space-x-4 py-4 bg-gray-100">
        <a @click="changeLanguage('es')" href="#" class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
          <img src="@/assets/ar.svg" class="h-8 rounded-full"/>
          <span class="font-semibold ml-2">{{ $t('menu.español') }}</span>
        </a>
        <a @click="changeLanguage('en')" href="#" class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
          <img src="@/assets/us.svg" class="h-8 rounded-full"/>
          <span class="font-semibold ml-2">{{ $t('menu.ingles') }}</span>
        </a>
      </div>

      <div class="w-full h-1" style="background-color: #3c3c3a;"></div>

    </div>
  </header>
</template>


<script lang="ts">
import { defineComponent } from 'vue';

import idiomaService from '@/services/idioma.services';

export default defineComponent({
  methods: {
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      idiomaService.updateIdioma(lang);
    }
  },
});
</script>